import { useQuery } from '@tanstack/react-query';
import { issueDetailApi, IssueAttachment } from '../api/issueDetailApi';

export const useIssueAttachments = (issueKey?: string) => {
  const { data: attachments = [], isLoading, error } = useQuery<IssueAttachment[]>({
    queryKey: ['issue-attachments', issueKey],
    queryFn: () => issueDetailApi.fetchIssueAttachments(issueKey as string),
    enabled: !!issueKey,
  });

  return { attachments, isLoading, error: error as Error | null };
};
